import { useOutletContext } from "react-router-dom";
import { Field, Input, Select, Button } from "@/admin/ui";

export default function UserSettings() {
    const { user, company } = useOutletContext();

    return (
        <div data-testid="user-settings-page">
            <div className="max-w-3xl">
                <div className="inline-flex items-center gap-3 text-[11px] font-semibold tracking-[0.22em] uppercase text-neutral-500">
                    <span className="h-px w-6 bg-neutral-300" />
                    Settings
                </div>
                <h1 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-black">
                    Workspace preferences
                </h1>
                <p className="mt-3 text-[14px] text-neutral-600">
                    Personal preferences for how CEO’s GPT works for you. Company-wide settings live in the Admin Panel.
                </p>
            </div>

            <div className="mt-8 space-y-5">
                <Section title="Account">
                    <Field label="Name">
                        <Input defaultValue={user.name} onChange={() => {}} />
                    </Field>
                    <Field label="Email">
                        <Input defaultValue={user.email} disabled />
                    </Field>
                    <Field label="Phone">
                        <Input defaultValue={user.phone || ""} onChange={() => {}} />
                    </Field>
                    <Field label="Language">
                        <Select defaultValue="en" onChange={() => {}}>
                            <option value="en">English</option>
                            <option value="hi">Hindi</option>
                            <option value="ar">Arabic</option>
                        </Select>
                    </Field>
                </Section>

                <Section title="Company">
                    <Field label="Company"><Input value={company?.name || "—"} readOnly /></Field>
                    <Field label="Currency"><Input value={company?.currency || "—"} readOnly /></Field>
                    <Field label="Plan"><Input value={company?.plan_type || "—"} readOnly /></Field>
                </Section>

                <Section title="Notifications">
                    <Toggle label="Email me about new tasks" defaultChecked />
                    <Toggle label="Email me about approvals" defaultChecked />
                    <Toggle label="Weekly workspace digest" />
                </Section>

                <div className="flex justify-end gap-2">
                    <Button variant="ghost">Discard</Button>
                    <Button onClick={() => alert("Preferences saved (placeholder).")} data-testid="user-settings-save">
                        Save preferences
                    </Button>
                </div>
            </div>
        </div>
    );
}

function Section({ title, children }) {
    return (
        <div className="glass rounded-3xl p-6 sm:p-8">
            <div className="text-[10px] font-semibold tracking-[0.22em] uppercase text-violet-600">{title}</div>
            <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-4">{children}</div>
        </div>
    );
}

function Toggle({ label, defaultChecked }) {
    return (
        <label className="col-span-full sm:col-span-1 flex items-center justify-between rounded-2xl border border-black/5 bg-white px-4 py-3 cursor-pointer">
            <span className="text-[13.5px] text-black">{label}</span>
            <input
                type="checkbox"
                defaultChecked={defaultChecked}
                className="h-4 w-8 appearance-none rounded-full bg-neutral-200 relative checked:bg-violet-500 transition-all"
                style={{ WebkitAppearance: "none" }}
            />
        </label>
    );
}
